import { motion } from 'framer-motion';
import HeroSearch from './HeroSearch';
import './HeroSection.css';

function HeroSection() {
  return (
    <section className="hero" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1497215728101-856f4ea42174?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')` }}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <HeroSearch />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <p className="hero-subtitle">Your dream career awaits! Explore thousands of job opportunities with all the information you need.</p>
        </motion.div>
      </div>
    </section>
  );
}

export default HeroSection; 